import { ICoreLoggerConfigurator } from "../api/ICoreLoggerConfigurator";
import { LoggingLevel } from "../api/LoggingLevel";
import { LoggingLevelMapper } from "./CoreLogger";
import { IContext, ILoggerOpts, ILogger } from "js-logger";
const Logger: ILogger = require("js-logger");
export const GLOBAL_LOGGER: string = "__GLOBAL_LOGGER__";

/**
 *
 * Configurator for the Global Logger
 * in order for the named logger to be working the Global logger must have been configured (otherwise it defaults to NONE/OFF)
 */
export const CoreLoggerConfigurator: ICoreLoggerConfigurator = {
    useDefaults() {
        Logger.useDefaults(
            {
                logLevel: Logger.DEBUG,
                formatter: function(messages, context) {
                    //  messages.unshift(`[${context.level.name} ${new Date().toUTCString()} - ${context.name || "__GLOBAL_LOGGER__"}] `);
                    messages.unshift(`[${context.name || GLOBAL_LOGGER}] `);
                }
                // formatter: FormatterConstants.fullLogFormat
            }
        )
        return this;
    },

    setFormatter(formatter: (messages: any[], context: IContext) => void) {
        Logger.setHandler(Logger.createDefaultHandler({ formatter: formatter }));
    },

    setLevel(logLevel: LoggingLevel) {
        Logger.setLevel(LoggingLevelMapper.get(logLevel));
    },
}




